// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hero-banner-style.top-section-gap {
  color: #fff;
  background-color: #181a20;
  font-family: "Inter", sans-serif;
  font-weight: 400;
  min-height: calc(100vh - 58px);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizeLegibility;
  position: relative;
  max-width: 100%;
  overflow-x: hidden;
  padding-top: 0;
  padding-bottom: 40px;
}

body.light_theme .hero-banner-style.top-section-gap {
  color: #0a0a0a;
  background-color: #ffffff;
}

.hero-banner-style.top-section-gap a {
  text-decoration: none;
  transition: 0.5s all;
}

/* ========== CONTAINER + BOOTSTRAP ========== */

.hero-banner-style.top-section-gap .container {
  max-width: 1380px;
  padding: 0 20px;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
}

.hero-banner-style.top-section-gap .row {
  display: flex;
  flex-wrap: wrap;
  margin-left: -12px;
  margin-right: -12px;
}

.hero-banner-style.top-section-gap .row > * {
  padding-left: 12px;
  padding-right: 12px;
  box-sizing: border-box;
}

.hero-banner-style.top-section-gap .align-items-center {
  align-items: center !important;
}

.hero-banner-style.top-section-gap .justify-content-center {
  justify-content: center !important;
}

.hero-banner-style.top-section-gap .text-center {
  text-align: center !important;
}

.hero-banner-style.top-section-gap .col-md-12 {
  flex: 0 0 auto;
  width: 100%;
}

@media (min-width: 992px) {
  .hero-banner-style.top-section-gap .col-lg-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
}

/* ========== HERO / TITLE ========== */

.hero-banner-style.top-section-gap section.faq_sec {
  padding: 40px 0 0;
}

.hero-banner-style.top-section-gap section.faq_sec .section-title {
  margin-bottom: 20px;
}

.hero-banner-style.top-section-gap .section-title {
  margin-bottom: 60px;
}

/* Full gold title — override PoR black→gold leak; slightly larger */
.hero-banner-style.top-section-gap .text-gradient,
body.light_theme .hero-banner-style.top-section-gap .text-gradient {
  background: linear-gradient(135deg, #000000 30%, #d1aa67 80%, #d1aa67 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.hero-banner-style.top-section-gap .section-title h1 {
  font-family: "Inter", sans-serif;
  font-size: 3.4rem;
  font-weight: 600;
  line-height: 1.25;
  margin: 0;
}

/* ========== CONTENT (.termsofuse is a DIV on this page) ========== */

.hero-banner-style.top-section-gap .termsofuse {
  color: #fff;
  padding: 40px 0 60px;
}

body.light_theme .hero-banner-style.top-section-gap .termsofuse {
  color: #161616;
}

/* Headings slightly larger */
.hero-banner-style.top-section-gap .termsofuse h3 {
  font-size: 30px;
  font-weight: 550;
  margin: 28px 0 12px;
  color: inherit;
}

/* Paragraphs smaller */
.hero-banner-style.top-section-gap .termsofuse p {
  font-size: 15px;
  font-weight: 400;
  line-height: 24px;
  margin: 0 0 14px;
}

.hero-banner-style.top-section-gap .termsofuse ul {
  list-style: disc !important;
  padding-left: 30px !important;
  padding-bottom: 15px !important;
  margin: 0 0 4px;
}

.hero-banner-style.top-section-gap .termsofuse li {
  list-style-type: disc !important;
  font-size: 15px;
  line-height: 24px;
  margin-bottom: 6px;
}

.hero-banner-style.top-section-gap .termsofuse a {
  color: #d1aa67;
}

.hero-banner-style.top-section-gap .termsofuse strong {
  font-weight: 700;
}

/* ========== RESPONSIVE ========== */

@media screen and (max-width: 1700px) {
  .hero-banner-style.top-section-gap .container {
    max-width: 90%;
  }
}

@media screen and (max-width: 1367px) {
  .hero-banner-style.top-section-gap .section-title h1 {
    font-size: 40px;
  }

  .hero-banner-style.top-section-gap .termsofuse {
    padding: 20px 0;
  }

  .hero-banner-style.top-section-gap .termsofuse li {
    font-size: 14px;
  }

  .hero-banner-style.top-section-gap .termsofuse p {
    font-size: 14px;
  }
}

@media screen and (max-width: 1200px) {
  .hero-banner-style.top-section-gap .container {
    max-width: 95%;
  }

  .hero-banner-style.top-section-gap .section-title {
    margin-bottom: 30px;
  }
}

@media screen and (max-width: 991px) {
  .hero-banner-style.top-section-gap section.faq_sec {
    padding: 50px 0 0;
  }

  .hero-banner-style.top-section-gap section.faq_sec .section-title {
    margin-bottom: 0;
  }

  .hero-banner-style.top-section-gap .section-title h1 {
    font-size: 34px;
  }

  .hero-banner-style.top-section-gap .termsofuse p {
    font-size: 14px;
  }
}

@media screen and (max-width: 767px) {
  .hero-banner-style.top-section-gap .container {
    max-width: 98%;
  }

  .hero-banner-style.top-section-gap section.faq_sec {
    padding: 35px 0 0;
  }

  .hero-banner-style.top-section-gap .termsofuse {
    padding: 15px 0 20px;
  }

  .hero-banner-style.top-section-gap .section-title h1 {
    font-size: 28px;
  }

  .hero-banner-style.top-section-gap .termsofuse h3 {
    font-size: 18px;
  }

  .hero-banner-style.top-section-gap .termsofuse p {
    font-size: 13px;
  }

  .hero-banner-style.top-section-gap .termsofuse li {
    font-size: 13px;
    line-height: 22px;
  }
}

@media screen and (max-width: 660px) {
  .hero-banner-style.top-section-gap .termsofuse h3 {
    font-size: 20px;
  }
}

@media screen and (max-width: 480px) {
  .hero-banner-style.top-section-gap .termsofuse ul {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .hero-banner-style.top-section-gap .termsofuse p {
    font-size: 12px;
  }
}

@media screen and (max-width: 414px) {
  .hero-banner-style.top-section-gap .termsofuse li {
    font-size: 12px;
    line-height: 20px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/ui/Pages/ComplaintsHandlingProcedure/Complaints.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,yBAAyB;EACzB,gCAAgC;EAChC,gBAAgB;EAChB,8BAA8B;EAC9B,mCAAmC;EACnC,kCAAkC;EAClC,kCAAkC;EAClC,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA,gDAAgD;;AAEhD;EACE,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE;IACE,cAAc;IACd,mBAAmB;EACrB;AACF;;AAEA,uCAAuC;;AAEvC;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,oEAAoE;AACpE;;EAEE,2EAA2E;EAC3E,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;AACX;;AAEA,sEAAsE;;AAEtE;EACE,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA,6BAA6B;AAC7B;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,qCAAqC;;AAErC;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;IACf,iBAAiB;EACnB;AACF","sourcesContent":[".hero-banner-style.top-section-gap {\n  color: #fff;\n  background-color: #181a20;\n  font-family: \"Inter\", sans-serif;\n  font-weight: 400;\n  min-height: calc(100vh - 58px);\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  text-rendering: optimizeLegibility;\n  position: relative;\n  max-width: 100%;\n  overflow-x: hidden;\n  padding-top: 0;\n  padding-bottom: 40px;\n}\n\nbody.light_theme .hero-banner-style.top-section-gap {\n  color: #0a0a0a;\n  background-color: #ffffff;\n}\n\n.hero-banner-style.top-section-gap a {\n  text-decoration: none;\n  transition: 0.5s all;\n}\n\n/* ========== CONTAINER + BOOTSTRAP ========== */\n\n.hero-banner-style.top-section-gap .container {\n  max-width: 1380px;\n  padding: 0 20px;\n  margin-left: auto;\n  margin-right: auto;\n  width: 100%;\n}\n\n.hero-banner-style.top-section-gap .row {\n  display: flex;\n  flex-wrap: wrap;\n  margin-left: -12px;\n  margin-right: -12px;\n}\n\n.hero-banner-style.top-section-gap .row > * {\n  padding-left: 12px;\n  padding-right: 12px;\n  box-sizing: border-box;\n}\n\n.hero-banner-style.top-section-gap .align-items-center {\n  align-items: center !important;\n}\n\n.hero-banner-style.top-section-gap .justify-content-center {\n  justify-content: center !important;\n}\n\n.hero-banner-style.top-section-gap .text-center {\n  text-align: center !important;\n}\n\n.hero-banner-style.top-section-gap .col-md-12 {\n  flex: 0 0 auto;\n  width: 100%;\n}\n\n@media (min-width: 992px) {\n  .hero-banner-style.top-section-gap .col-lg-8 {\n    flex: 0 0 auto;\n    width: 66.66666667%;\n  }\n}\n\n/* ========== HERO / TITLE ========== */\n\n.hero-banner-style.top-section-gap section.faq_sec {\n  padding: 40px 0 0;\n}\n\n.hero-banner-style.top-section-gap section.faq_sec .section-title {\n  margin-bottom: 20px;\n}\n\n.hero-banner-style.top-section-gap .section-title {\n  margin-bottom: 60px;\n}\n\n/* Full gold title — override PoR black→gold leak; slightly larger */\n.hero-banner-style.top-section-gap .text-gradient,\nbody.light_theme .hero-banner-style.top-section-gap .text-gradient {\n  background: linear-gradient(135deg, #000000 30%, #d1aa67 80%, #d1aa67 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n.hero-banner-style.top-section-gap .section-title h1 {\n  font-family: \"Inter\", sans-serif;\n  font-size: 3.4rem;\n  font-weight: 600;\n  line-height: 1.25;\n  margin: 0;\n}\n\n/* ========== CONTENT (.termsofuse is a DIV on this page) ========== */\n\n.hero-banner-style.top-section-gap .termsofuse {\n  color: #fff;\n  padding: 40px 0 60px;\n}\n\nbody.light_theme .hero-banner-style.top-section-gap .termsofuse {\n  color: #161616;\n}\n\n/* Headings slightly larger */\n.hero-banner-style.top-section-gap .termsofuse h3 {\n  font-size: 30px;\n  font-weight: 550;\n  margin: 28px 0 12px;\n  color: inherit;\n}\n\n/* Paragraphs smaller */\n.hero-banner-style.top-section-gap .termsofuse p {\n  font-size: 15px;\n  font-weight: 400;\n  line-height: 24px;\n  margin: 0 0 14px;\n}\n\n.hero-banner-style.top-section-gap .termsofuse ul {\n  list-style: disc !important;\n  padding-left: 30px !important;\n  padding-bottom: 15px !important;\n  margin: 0 0 4px;\n}\n\n.hero-banner-style.top-section-gap .termsofuse li {\n  list-style-type: disc !important;\n  font-size: 15px;\n  line-height: 24px;\n  margin-bottom: 6px;\n}\n\n.hero-banner-style.top-section-gap .termsofuse a {\n  color: #d1aa67;\n}\n\n.hero-banner-style.top-section-gap .termsofuse strong {\n  font-weight: 700;\n}\n\n/* ========== RESPONSIVE ========== */\n\n@media screen and (max-width: 1700px) {\n  .hero-banner-style.top-section-gap .container {\n    max-width: 90%;\n  }\n}\n\n@media screen and (max-width: 1367px) {\n  .hero-banner-style.top-section-gap .section-title h1 {\n    font-size: 40px;\n  }\n\n  .hero-banner-style.top-section-gap .termsofuse {\n    padding: 20px 0;\n  }\n\n  .hero-banner-style.top-section-gap .termsofuse li {\n    font-size: 14px;\n  }\n\n  .hero-banner-style.top-section-gap .termsofuse p {\n    font-size: 14px;\n  }\n}\n\n@media screen and (max-width: 1200px) {\n  .hero-banner-style.top-section-gap .container {\n    max-width: 95%;\n  }\n\n  .hero-banner-style.top-section-gap .section-title {\n    margin-bottom: 30px;\n  }\n}\n\n@media screen and (max-width: 991px) {\n  .hero-banner-style.top-section-gap section.faq_sec {\n    padding: 50px 0 0;\n  }\n\n  .hero-banner-style.top-section-gap section.faq_sec .section-title {\n    margin-bottom: 0;\n  }\n\n  .hero-banner-style.top-section-gap .section-title h1 {\n    font-size: 34px;\n  }\n\n  .hero-banner-style.top-section-gap .termsofuse p {\n    font-size: 14px;\n  }\n}\n\n@media screen and (max-width: 767px) {\n  .hero-banner-style.top-section-gap .container {\n    max-width: 98%;\n  }\n\n  .hero-banner-style.top-section-gap section.faq_sec {\n    padding: 35px 0 0;\n  }\n\n  .hero-banner-style.top-section-gap .termsofuse {\n    padding: 15px 0 20px;\n  }\n\n  .hero-banner-style.top-section-gap .section-title h1 {\n    font-size: 28px;\n  }\n\n  .hero-banner-style.top-section-gap .termsofuse h3 {\n    font-size: 18px;\n  }\n\n  .hero-banner-style.top-section-gap .termsofuse p {\n    font-size: 13px;\n  }\n\n  .hero-banner-style.top-section-gap .termsofuse li {\n    font-size: 13px;\n    line-height: 22px;\n  }\n}\n\n@media screen and (max-width: 660px) {\n  .hero-banner-style.top-section-gap .termsofuse h3 {\n    font-size: 20px;\n  }\n}\n\n@media screen and (max-width: 480px) {\n  .hero-banner-style.top-section-gap .termsofuse ul {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n  }\n\n  .hero-banner-style.top-section-gap .termsofuse p {\n    font-size: 12px;\n  }\n}\n\n@media screen and (max-width: 414px) {\n  .hero-banner-style.top-section-gap .termsofuse li {\n    font-size: 12px;\n    line-height: 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
